export const IDENTITY_BASE_URL = ((import.meta.env.VITE_IDENTITY_BASE_URL as string | undefined) ?? "").replace(/\/$/, "");
export const IDENTITY_TENANT_SLUG = ((import.meta.env.VITE_IDENTITY_TENANT_SLUG as string | undefined) ?? "").trim();

export function tenantLoginUrl(): string {
  if (!IDENTITY_BASE_URL) {
    const fallback = new URL("/sign-in", window.location.origin);
    fallback.searchParams.set("return_to", window.location.href);
    return `${fallback.pathname}${fallback.search}`;
  }
  const url = new URL(`/t/${encodeURIComponent(IDENTITY_TENANT_SLUG)}/login`, IDENTITY_BASE_URL);
  url.searchParams.set("return_to", window.location.href);
  return url.toString();
}

// CD captures this global at module evaluation, before the host renders.
(window as unknown as { __STUDIO_SIGNIN_URL__?: string }).__STUDIO_SIGNIN_URL__ = tenantLoginUrl();
